import { INVOICE_CONTADO_TYPE_CODE, INVOICE_CREDIT_TYPE_CODE, INVOICE_HOLDING_TYPE_CODE } from "./Constants";

/**
 * Con `no_auto_cancel_contado` activo, la venta de contado no se cobra al facturar:
 * el documento nace pendiente y se cancela despues con un Recibo de Dinero. En ese
 * escenario no se capturan ni se persisten formas de pago, porque un pago por el
 * total dejaria el documento con saldo 0 y el recibo no se podria generar
 * (ver normalizeClientStatusRow en @utils/DocumentStatus).
 *
 * El apartado no entra en la regla: su abono inicial es un pago real.
 */
export const shouldCapturePaymentWays = (
    tipo?: string | number | null,
    noAutoCancelContado = false,
): boolean => {
    const documentType = `${tipo ?? ""}`;
    if (documentType == INVOICE_HOLDING_TYPE_CODE) {
        return true;
    }
    if (documentType == INVOICE_CONTADO_TYPE_CODE) {
        return !noAutoCancelContado;
    }
    return false;
};

/**
 * Codigo interno de condicion de venta (clave de SALE_CONDITIONS) que se declara en
 * el comprobante electronico. Un contado que se cobra despues por recibo se emite
 * como credito (SALE_CONDITIONS[1] = '02'); el `tipo` del documento no cambia, para
 * que la UI, los listados y el flujo de recibos lo sigan tratando como contado.
 */
export const resolveSaleConditionCode = (
    tipo?: string | number | null,
    esApartado = false,
    noAutoCancelContado = false,
): string => {
    const documentType = `${tipo ?? INVOICE_CONTADO_TYPE_CODE}`;
    if (esApartado || documentType == INVOICE_HOLDING_TYPE_CODE) {
        return INVOICE_HOLDING_TYPE_CODE;
    }
    if (documentType == INVOICE_CONTADO_TYPE_CODE && noAutoCancelContado) {
        return INVOICE_CREDIT_TYPE_CODE;
    }
    return documentType;
};

/** Plazo minimo en dias: Hacienda exige PlazoCredito cuando CondicionVenta es credito. */
export const MIN_CREDIT_TERM_DAYS = 1;

/**
 * Plazo a declarar en el comprobante. Una factura de contado convertida a credito por
 * `no_auto_cancel_contado` normalmente lleva plazo 0 (el campo solo se pide en credito),
 * lo que invalidaria el PlazoCredito del XML.
 */
export const resolveAtvCreditTerm = (plazo?: string | number | null, forcedCredit = false): number => {
    const days = Number(plazo || 0);
    if (!forcedCredit) {
        return days;
    }
    return Math.max(MIN_CREDIT_TERM_DAYS, days);
};
